import { FC, ReactNode } from "react";
import { NotificationTag } from "../miscellaneous/toastsAtom";
import { Banner } from "./Banner";
import caution from "../images/caution.svg";
import error from "../images/error.svg";
import success from "../images/success.svg";
import info from "../images/info.svg";
import { useOnElementClickRef } from "../../forms/hooks/useOnElementClickRef";

type Props = {
  readonly children: ReactNode;
  readonly tag: NotificationTag;
  readonly handleClose?: () => void;
  readonly id?: string;
};

const getImageDetails = function (tag: NotificationTag) {
  switch (tag) {
    case "success":
      return { path: success, background: "tw-bg-success" };
    case "warning":
      return { path: caution, background: "tw-bg-warning" };
    case "danger":
      return { path: error, background: "tw-bg-danger" };
    case "info":
      return { path: info, background: "tw-bg-info" };
  }
};

// eslint-disable-next-line @typescript-eslint/prefer-readonly-parameter-types
export const BannerNotification: FC<Props> = ({
  children,
  tag,
  handleClose,
  id,
}) => {
  const imageDetails = getImageDetails(tag);
  const colorClass = imageDetails.background;
  const ref = useOnElementClickRef<HTMLDivElement>();

  return (
    <Banner id={id}>
      <div
        className={`tw-absolute tw-top-0 tw-left-0 tw-h-full tw-w-12 tw-flex tw-items-center tw-justify-center ${colorClass}`}
      >
        <img src={imageDetails.path} alt="notification" />
      </div>
      <div className="tw-mx-10">{children}</div>
      <div
        ref={ref}
        className="tw-cursor-pointer tw-text-2xl tw-absolute tw-right-6 tw-ml-3"
        onClick={handleClose}
        role="button"
        aria-label="Close notification"
        tabIndex={0}
      >
        &times;
      </div>
    </Banner>
  );
};
